import { Routes, Route } from 'react-router-dom'
import { Toaster } from '@/components/ui/Toaster'
import Dashboard from '@/pages/Dashboard'
import RankingsPage from '@/pages/RankingsPage'
import SeasonPage from '@/pages/SeasonPage'
import MatchupPage from '@/pages/MatchupPage'
import Layout from '@/components/Layout'
import ActivityPanel from '@/components/ActivityPanel'
import './App.css'

function App() {
  return (
    <div className="App">
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/season/:divisionId" element={<SeasonPage />} />
          <Route path="/division/:divisionId" element={<RankingsPage />} />
          <Route path="/division/:divisionId/matchup" element={<MatchupPage />} />
        </Routes>
      </Layout>
      <Toaster />
      {import.meta.env.DEV && <ActivityPanel />}
    </div>
  )
}

export default App